export default [
  {
    label: 'Cookie Preferences',
    href: 'https://domo.com/company/cookies',
  },
  {
    label: 'Privacy & Cookie Policy',
    href: 'https://domo.com/company/privacy-policy',
  },
  {
    label: 'Patents',
    href: 'https://domo.com/company/patents',
  },
];
